<template>
 <router-view></router-view>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useLockScreen } from '@/composables/useLockScreen';

export default {
  name: 'App',
  setup() {
    const { startIdleTimer, stopIdleTimer, clearLockState } = useLockScreen();
    return { startIdleTimer, stopIdleTimer, clearLockState };
  },
  computed: {
    ...mapGetters('system', ['logo'])
  },
  methods: {
    ...mapActions('system', ['fetchSettings']),
    updateFavicon(url) {
      const link = document.querySelector("link[rel='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = url || require('@/assets/images/logo/aai_logo_new.png');
      document.head.appendChild(link);
    }
  },
  mounted() {
    this.fetchSettings();

    // Start idle timer if user is authenticated
    const token = localStorage.getItem('auth_token');
    if (token) {
      this.startIdleTimer();
    }
  },
  beforeUnmount() {
    this.stopIdleTimer();
  },
  watch: {
    logo(url) {
      this.updateFavicon(url);
    },
    // Watch for route changes to manage idle timer
    '$route'(to) {
      const token = localStorage.getItem('auth_token');
      if (to.name === 'login') {
        // Clear lock state on login page
        this.clearLockState();
      } else if (token && to.name !== 'lock-screen') {
        // Restart idle timer on authenticated pages
        this.startIdleTimer();
      }
    }
  },
  components: {
  }
}
</script>
